import { render, staticRenderFns } from "./SecurityManager.vue?vue&type=template&id=4158727c"
import script from "./SecurityManager.vue?vue&type=script&lang=js"
export * from "./SecurityManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports